import React, { useEffect } from "react";
import PageLayout from "@/components/layout/PageLayout";
import { Hero, Section } from "@/components/layout/Sections";
import ContactForm from "@/components/ContactForm";
import { useLocation } from "react-router-dom";
import { MapPin, Phone, Mail, Clock } from "lucide-react";
import { WhatsAppIcon } from "@/components/icons/WhatsAppIcon";

export default function Contatti() {
  const location = useLocation();
  useEffect(() => {
    if (location.hash === "#form") {
      const el = document.getElementById("form");
      if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }, [location.hash]);

  return (
    <PageLayout>
      <Hero
        image="/showroom/contatti-neutral.svg"
        eyebrow="Scrivici · Contatti"
        title="Scrivici"
        subtitle="Rispondiamo velocemente e ti mettiamo in contatto con la persona giusta."
        height="55vh"
      />
      <Section>
        <div className="grid md:grid-cols-5 gap-10">
          <div className="md:col-span-2 space-y-8">
            <p className="text-gray-600 text-lg">Ti aspettiamo nella nostra concessionaria.</p>
            <ul className="space-y-5 font-body">
              <Info icon={<MapPin size={18} />} label="Indirizzo" value="Via Serio 87, 24020 Casnigo (BG)" />
              <Info icon={<Phone size={18} />} label="Telefono" value={<a href="tel:+390350276966" className="hover:text-[color:var(--nsa-orange)]">+39 035 027 6966</a>} />
              <Info icon={<WhatsAppIcon size={18} />} label="WhatsApp" value={<a href="https://wa.me/393494062553" target="_blank" rel="noopener noreferrer" className="hover:text-[color:var(--nsa-orange)]">+39 349 406 2553</a>} />
              <Info icon={<Mail size={18} />} label="Email" value={<a href="mailto:info@nsamotors.eu" className="hover:text-[color:var(--nsa-orange)]">info@nsamotors.eu</a>} />
              <Info
                icon={<Clock size={18} />}
                label="Orari"
                value={
                  <div className="space-y-0.5">
                    <div><span className="inline-block w-28">Lun–Ven</span>08:30–12:30 · 14:30–19:00</div>
                    <div><span className="inline-block w-28">Sabato</span>08:30–12:30 · 14:30–18:00</div>
                    <div className="text-gray-500"><span className="inline-block w-28">Domenica</span>Chiuso</div>
                  </div>
                }
              />
            </ul>
          </div>
          <div className="md:col-span-3">
            <ContactForm />
          </div>
        </div>
      </Section>
    </PageLayout>
  );
}

function Info({ icon, label, value }) {
  return (
    <li className="flex gap-4 items-start">
      <span className="text-[color:var(--nsa-orange)] mt-1">{icon}</span>
      <div>
        <div className="label-eyebrow text-gray-500">{label}</div>
        <div className="text-gray-900 mt-1">{value}</div>
      </div>
    </li>
  );
}
